import { Zap } from "lucide-react";

const ITEMS = [
  "ADNAN KAHVECİ",
  "BEYKENT",
  "YAKUPLU",
  "MARMARA",
  "BARIŞ MAHALLESİ",
  "GÜRPINAR",
  "DEREAĞZI",
  "KAVAKLI",
  "CUMHURİYET",
  "GARANTİLİ İŞÇİLİK",
  "HIZLI ADRESE MÜDAHALE",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="area-marquee"
      className="relative py-6 border-y border-slate-800/80 bg-[#0A0F18] overflow-hidden"
    >
      <div className="flex w-max animate-marquee items-center gap-10 pr-10">
        {row.map((item, i) => (
          <div key={i} className="flex items-center gap-10 shrink-0">
            <span className="font-display font-semibold text-sm sm:text-base tracking-[0.15em] text-slate-500 uppercase whitespace-nowrap">
              {item}
            </span>
            <Zap className="w-3.5 h-3.5 text-amber-500/60 shrink-0" fill="currentColor" />
          </div>
        ))}
      </div>
    </div>
  );
};
